var map = {
	"./help-centre/app.config.js": 4227,
	"./login/app.config.js": 125,
	"./myaccount/app.config.js": 475,
	"./players/app.config.js": 2258,
	"./search/app.config.js": 1876,
	"./store/app.config.js": 8795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5595;